import { inject } from '@angular/core/testing';
import { UserdataService } from '../../../service/userdata.service';
import { serverurl } from './../../../../environments/environment';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { Userdata } from '../../../interfaces/userdata';

@Component({
    selector: 'rr-user-avatar',
    standalone: false,
    templateUrl: './user-avatar.component.html',
    styleUrl: './user-avatar.component.scss'
})
export class UserAvatarComponent {
    serverurl = serverurl;

    @Input() user: Userdata | null = null
}
